<nz-spin [nzSpinning]="loading$ | async" nzSize="large">
  <form [formGroup]="form" nz-form>
    <nz-form-item>
      <nz-form-control>
        <nz-radio-group formControlName="lotType" nzButtonStyle="solid">
          <label *ngFor="let lotType of lotTypes" nz-radio-button [nzValue]="lotType">
            {{ lotType.toUpperCase() | translate }}
          </label>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item>

    <nz-divider></nz-divider>

    <nz-form-item>
      <nz-form-label [nzSm]="5" [nzXs]="24" class="align-start">
        {{ 'LOT_INFO.AUCTION' | translate }} / {{ 'LOT_INFO.TITLE' | translate }}
      </nz-form-label>
      <nz-form-control [nzSm]="24" [nzXs]="24" [nzExtra]="'NO_TARGET_AUCTION_TOOLTIP' | translate">
        <nz-row [nzGutter]="[5, 5]">
          <nz-col nzSpan="12">
            <nz-select
              formControlName="auctionName"
              nzShowSearch
              [nzDropdownMatchSelectWidth]="false"
              [nzPlaceHolder]="'LOT_INFO.AUCTION' | translate"
            >
              <nz-option
                *ngFor="let auction of auctions$ | async"
                [nzLabel]="auction"
                [nzValue]="auction"
              ></nz-option>
            </nz-select>
          </nz-col>

          <nz-col nzSpan="12">
            <input
              formControlName="code"
              nz-input
              type="tel"
              inputmode="numeric"
              placeholder="{{ 'BID_NUMBER' | translate }}"
            />
          </nz-col>
        </nz-row>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSm]="5" [nzXs]="24" class="align-start">
        {{ 'DATE' | translate }}
      </nz-form-label>
      <nz-form-control [nzSm]="24" [nzXs]="24">
        <nz-row [nzGutter]="[5, 5]">
          <nz-col nzSpan="12">
            <nz-date-picker
              formControlName="date"
              [nzPlaceHolder]="'DATE' | translate"
              style="width: 100%"
            ></nz-date-picker>
          </nz-col>
          <nz-col nzSpan="12">
            <nz-time-picker
              formControlName="time"
              [nzPlaceHolder]="'TIME' | translate"
              style="width: 100%"
            ></nz-time-picker>
          </nz-col>
        </nz-row>
      </nz-form-control>
    </nz-form-item>

    <nz-divider></nz-divider>

    <nz-form-item>
      <nz-form-label [nzSm]="5" [nzXs]="24" class="align-start">
        {{ 'AUTO' | translate }}
      </nz-form-label>
      <nz-form-control [nzSm]="24" [nzXs]="24">
        <nz-row [nzGutter]="[5, 5]" style="padding-bottom: 5px">
          <nz-col nzSpan="12">
            <nz-select
              formControlName="company"
              nzShowSearch
              [nzDropdownMatchSelectWidth]="false"
              [nzPlaceHolder]="'COMPANY' | translate"
              [nzLoading]="makersLoading$ | async"
            >
              <nz-option
                *ngFor="let maker of makers$ | async"
                [nzValue]="maker.name"
                [nzLabel]="maker.name"
              >
              </nz-option>
            </nz-select>
          </nz-col>
          <nz-col nzSpan="12">
            <input
              formControlName="modelName"
              nz-input
              [placeholder]="'MODEL' | translate"
              [nzAutocomplete]="modelAuto"
              type="text"
            />
          </nz-col>
        </nz-row>

        <nz-autocomplete #modelAuto>
          <nz-auto-option *ngIf="marksLoading$ | async" disabled>
            <i nz-icon nzType="loading" class="mr-2"></i>
            {{ 'LOADING_MODEL' | translate }}
          </nz-auto-option>

          <nz-auto-option
            *ngFor="let mark of filteredMarks$ | async"
            [nzValue]="mark.name"
            [nzLabel]="mark.name"
          >
            {{ mark.name }}
          </nz-auto-option>
        </nz-autocomplete>

        <nz-row [nzGutter]="[5, 5]">
          <nz-col nzSpan="12">
            <input
              formControlName="frame"
              nz-input
              placeholder="{{ 'FRAME_MODEL' | translate }}"
              type="text"
            />
          </nz-col>
          <nz-col nzSpan="12">
            <nz-date-picker
              formControlName="year"
              nzPlaceHolder="{{ 'LOT_INFO.YEAR' | translate }}"
              [nzMode]="'year'"
              [nzDisabledDate]="disabledYear"
              style="width: 100%"
            ></nz-date-picker>
          </nz-col>
        </nz-row>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSm]="5" [nzXs]="24" class="align-start">
        {{ 'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.ENGINE_CAPACITY' | translate }}
      </nz-form-label>
      <nz-form-control [nzSm]="24" [nzXs]="24">
        <nz-input-number
          formControlName="displacementNum"
          nzPlaceHolder="{{
            'AUCTION_LIST_TIP_MODAL.TIPS.GENERAL.ENGINE_CAPACITY_PLACEHOLDER' | translate
          }}"
          style="width: 100%"
          class="no-controls"
        ></nz-input-number>
      </nz-form-control>
    </nz-form-item>

    <nz-divider></nz-divider>

    <nz-form-item>
      <nz-form-label [nzSm]="5" [nzXs]="24" class="align-start">
        {{ 'AMOUNT' | translate }}, ¥
      </nz-form-label>
      <nz-form-control [nzSm]="24" [nzXs]="24">
        <nz-row [nzGutter]="[5, 5]">
          <nz-col nzSpan="12">
            <nz-input-number
              [nzMin]="0"
              [nzStep]="1000"
              nzInputMode="numeric"
              formControlName="startPrice"
              [nzPlaceHolder]="'LOT_INFO.START_PRICE' | translate"
              style="width: 100%"
            ></nz-input-number>
          </nz-col>

          <nz-col nzSpan="12">
            <nz-input-number
              [nzMin]="0"
              [nzStep]="1000"
              nzInputMode="numeric"
              formControlName="amount"
              [nzPlaceHolder]="'LOT_BIDDING_MODAL.YOUR_BID' | translate"
              style="width: 100%"
            ></nz-input-number>
          </nz-col>
        </nz-row>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-control
        [nzExtra]="form.get('conditionId')?.disabled ? ('FORM_VALID_TOOLTIP' | translate) : null"
      >
        <nz-select
          formControlName="conditionId"
          nzPlaceHolder="{{ 'LOT_BIDDING_MODAL.SELECT_CONDITIONS' | translate }}"
        >
          <nz-option
            *ngFor="let condition of conditions$ | async"
            [nzLabel]="condition.title | translate"
            [nzValue]="condition.id"
          >
          </nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-control>
        <textarea
          formControlName="comment"
          nz-input
          placeholder="{{ 'LOT_BIDDING_MODAL.YOUR_COMMENT' | translate }}"
          rows="2"
        ></textarea>
      </nz-form-control>
    </nz-form-item>

    <nz-divider></nz-divider>

    <nz-form-item>
      <nz-form-control>
        <label formControlName="createTranslation" nz-checkbox>
          {{ 'LOT_BIDDING_MODAL.TRANSLATE_REQUEST' | translate }}
        </label>
      </nz-form-control>
      <nz-form-control>
        <label formControlName="notify" nz-checkbox>
          {{ 'LOT_BIDDING_MODAL.NOTIFY_REQUEST' | translate }}
        </label>
      </nz-form-control>
    </nz-form-item>
  </form>
</nz-spin>

<footer *nzModalFooter>
  <button (click)="modal.close()" [disabled]="isPlacingBid$ | async" nz-button nzType="default">
    {{ 'CANCEL' | translate }}
  </button>
  <button
    (click)="placeBid()"
    [disabled]="loading$ | async"
    [nzLoading]="isPlacingBid$ | async"
    nz-button
    nzType="primary"
  >
    {{ 'LOT_BIDDING_MODAL.PLACE_YOUR_BID' | translate }}
  </button>
</footer>
